import { type } from 'arktype'

import type { FrRccwProductVersionFormat } from './model.ts'

export const frRccwProductVersions = [
  'product-fr-rcc-wakam-1.0.0-2026-08-02',
] as const satisfies FrRccwProductVersionFormat[]

export const frRccwProductVersionSchema = type('===', ...frRccwProductVersions)

export type FrRccwProductVersion = typeof frRccwProductVersionSchema.infer
